import React, { useMemo } from 'react'
import { useTranslation } from 'react-i18next'
import styles from './styles.module.css'
import HomePageDevelopmentToolsItem from './HomePageDevelopmentToolsItem'

const HomePageDevelopmentTools = () => {
  const { t } = useTranslation()

  const developmentToolsItems = useMemo(
    () => [
      {
        id: 'development-tools-credentials',
        title: t('homePage.developmentTools.credentials.title'),
        subtitle: t('homePage.developmentTools.credentials.subtitle'),
        route: process.env.URL_CREDENTIALS,
        textLink: t('homePage.developmentTools.credentials.externalLinkCredentials'),
      },
      {
        id: 'development-tools-webhook',
        title: t('homePage.developmentTools.webhook.title'),
        subtitle: t('homePage.developmentTools.webhook.subtitle'),
        route: process.env.URL_WEBHOOK,
        textLink: t('homePage.developmentTools.webhook.externalLinkWebhook'),
      },
    ],
    [t]
  )

  return (
    <section className={`${styles.developmentToolsWrapper} ${styles.homePageWrapper}`}>
      <div className={`${styles.developmentToolsContent}`}>
        <h2>{t('homePage.developmentTools.title')}</h2>
        <div className={styles.developmentToolsCard}>
          {developmentToolsItems.map(item => (
            <HomePageDevelopmentToolsItem
              key={item?.id}
              title={item?.title}
              subtitle={item?.subtitle}
              route={item?.route}
              textLink={item?.textLink}
            />
          ))}
        </div>
      </div>
    </section>
  )
}

export default HomePageDevelopmentTools
